import React, { useState, useEffect } from 'react';
import MainLayout from '../../layout/mainLayout';
import { Typography, Box, Stack, Divider, Tabs, Tab } from '@mui/material';
import ApiClient from '../../config/api';
import TabOne from './components/tabOne';
import TabTwo from './components/tabTwo';
import DetailModal from './components/detailModal';
import TransactionsTab from './components/transactionsTab';
import { setIsLoading } from '../../store/globalSlice';
import { useDispatch } from 'react-redux';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && <Box sx={{ width: '100%' }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const PAGE_SIZE = 20;

const Reports = () => {
  const dispatch = useDispatch();
  const api = ApiClient();
  const [data, setData] = useState([{ items: [] }]);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedTaskDetail, setSelectedTaskDetail] = useState(null);
  const [value, setValue] = useState(0);
  const [missionNo, setMissionNo] = useState(0);
  const [openDetail, setOpenDetail] = useState(false);
  const [openChangeStatusConfirm, setOpenChangeStatusConfirm] = useState('');
  const [transactions, setTransactions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [balanceAmount, setBalanceAmount] = useState(null);

  const getReports = async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await api.get(`/api/app/v1/shipito/reports`);
      setData(response.data.data);
    } catch (error) {
      console.error(
        'Error fetching reports:',
        error.message || error
      );
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const getBalance = async () => {
    try {
      const response = await api.get(`/api/app/v1/wallet/balance`);
      setBalanceAmount(response?.data?.amount);
    } catch (error) {
      console.error('Error fetching wallet balance:', error.message || error);
    }
  };

  const getTransactions = async ({ page = 0, append = false } = {}) => {
    try {
      if (append) {
        setLoadingMore(true);
      } else {
        dispatch(setIsLoading(true));
      }
      const response = await api.get(`/api/app/v1/wallet/transactions`, {
        params: {
          from: '',
          to: '',
          transactionTypeId: '',
          actionTypeId: '',
          pageSize: PAGE_SIZE,
          pageIndex: page,
        },
      });
      const nextItems = response?.data?.items || [];
      setTransactions((prev) => (append ? [...prev, ...nextItems] : nextItems));
      setTotalCount(response?.data?.total_count || nextItems.length);
      setPageIndex(page);
    } catch (error) {
      console.error(
        'Error fetching wallet transactions:',
        error.message || error
      );
    } finally {
      setLoadingMore(false);
      dispatch(setIsLoading(false));
    }
  };

  useEffect(() => {
    getBalance();
    getTransactions({ page: 0 });
  }, []);

  useEffect(() => {
    if (openDetail == false && value === 1) {
      getReports();
    }
  }, [openDetail, value]);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <MainLayout>
      <DetailModal
        openDetail={openDetail}
        setOpenDetail={setOpenDetail}
        selectedData={selectedData}
        missionNo={missionNo}
        data={data}
      />
      <Stack
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: 'background.paper',
          width: '100%',
        }}
      >
        <Typography
          paddingRight={'20px'}
          paddingLeft={'20px'}
          marginTop={'20px'}
          fontSize={20}
          fontWeight={600}
          textAlign={'left'}
        >
          گزارش‌ها
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="گزارش‌ها"
          sx={{
            width: '100%',
            borderBottom: '1px solid',
            borderColor: 'divider',
            mt: 1,
          }}
        >
          <Tab
            label="تراکنش‌ها"
            sx={{ width: '50%', fontSize: '14px' }}
            {...a11yProps(0)}
          />
          <Tab
            label="ماموریت‌ها"
            sx={{ width: '50%', fontSize: '14px' }}
            {...a11yProps(1)}
          />
        </Tabs>
      </Stack>
      <CustomTabPanel value={value} index={0}>
        <TransactionsTab
          items={transactions}
          totalCount={totalCount}
          balanceAmount={balanceAmount}
          loadingMore={loadingMore}
          onLoadMore={() => getTransactions({ page: pageIndex + 1, append: true })}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TabOne
          setOpenDetail={setOpenDetail}
          setSelectedData={setSelectedData}
          data={data}
          setSelectedTask={setSelectedTask}
          setMissionNo={setMissionNo}
          setSelectedTaskDetail={setSelectedTaskDetail}
          setOpenChangeStatusConfirm={setOpenChangeStatusConfirm}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <TabTwo />
      </CustomTabPanel>
    </MainLayout>
  );
};

export default Reports;
